import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PropertyOwnerSummaryDto } from '@workspace/data-types';
import { LuxonDatePipe } from '@workspace/ng-aura';

@Component({
  selector: 'etxe-property-application-seller-card',
  imports: [MatIconModule, MatButtonModule, LuxonDatePipe],
  templateUrl: './property-application-seller-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyApplicationSellerCardComponent {
  readonly ownerSummary = input.required<PropertyOwnerSummaryDto>();
  readonly contactOwner = output<void>();
}
